import React, { useState, useEffect } from 'react';
import { Card, Table, Typography, Toast, Button, Space } from '@douyinfe/semi-ui';
import { useSearchParams, useNavigate } from 'react-router-dom';
const { Text } = Typography;
import request from '../../utils/request';
import styles from './index.module.scss';

const Cash = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const uid = searchParams.get('uid');
    const [cashRecords, setCashRecords] = useState([]);
    const [cashPagination, setCashPagination] = useState({ currentPage: 1, pageSize: 10, total: 0 });
    const [cashLoading, setCashLoading] = useState(false);

    const formatTimestamp = (timestamp) => {
        if (!timestamp) return '-';
        const date = new Date(parseInt(timestamp));
        return date.toLocaleString();
    };

    const fetchCashRecords = async (page = 1, pageSize = 10) => {
        setCashLoading(true);
        try {
            const response = await request.get('/go/sp/su/list_user_cash_record/', {
                params: {
                    page: page - 1,
                    limit: pageSize,
                    uid: uid
                }
            });
            if (response.errno === 0) {
                setCashRecords(response.list || []);
                setCashPagination(prev => ({
                    ...prev,
                    currentPage: page,
                    total: response.total_cnt
                }));
            } else {
                Toast.error(response.errstr || '获取余额记录失败');
            }
        } catch (error) {
            console.error('获取余额记录失败:', error);
            Toast.error('获取余额记录失败');
        } finally {
            setCashLoading(false);
        }
    };

    useEffect(() => {
        fetchCashRecords();
    }, []);

    return (
        <div className={styles.cashContainer}>
            <Card
                title="余额变更记录"
                headerStyle={{ backgroundColor: 'var(--semi-color-bg-2)' }}
                className={styles.detailCard}
            >
                <Table
                    dataSource={cashRecords}
                    loading={cashLoading}
                    pagination={{
                        currentPage: cashPagination.currentPage,
                        pageSize: cashPagination.pageSize,
                        total: cashPagination.total,
                        onPageChange: (page) => fetchCashRecords(page, cashPagination.pageSize),
                        onPageSizeChange: (size) => fetchCashRecords(1, size)
                    }}
                    columns={[
                        {
                            title: '流水ID',
                            dataIndex: 'uid',
                            width: 120
                        },
                        {
                            title: '变动金额',
                            dataIndex: 'cash',
                            render: (text) => (
                                <Text type={text > 0 ? 'success' : 'danger'}>
                                    {text > 0 ? `+¥${(text / 100).toFixed(2)}` : `-¥${(Math.abs(text) / 100).toFixed(2)}`}
                                </Text>
                            )
                        },
                        {
                            title: '剩余余额',
                            dataIndex: 'cash_remain',
                            render: (text) => `¥${(text / 100).toFixed(2)}`
                        },
                        {
                            title: '变动类型',
                            dataIndex: 'typ',
                            render: (text) => {
                                const typeMap = {
                                    1: { text: '消耗', type: 'danger' },
                                    2: { text: '增加', type: 'success' }
                                };
                                const type = typeMap[text] || { text: '未知', type: 'tertiary' };
                                return <Text type={type.type}>{type.text}</Text>;
                            }
                        },
                        {
                            title: '备注',
                            dataIndex: 'info',
                            render: (text) => text || '-'
                        },
                        {
                            title: '创建时间',
                            dataIndex: 'create_time',
                            render: (text) => formatTimestamp(text)
                        }
                    ]}
                />
                <Space className={styles.actionButtons} style={{ marginTop: '24px' }}>
                    <Button type="tertiary" size="large" onClick={() => navigate(-1)}>返回</Button>
                </Space>
            </Card>
        </div>
    );
};

export default Cash;